module.exports = __webpack_public_path__ + "img/9788937483264.46c67bde.jpg";